import { $authHost } from './index';

export const fetchBasket = async () => {
    const { data } = await $authHost.get('/api/basket');
    return data;
};

export const addToBasket = async (deviceId, quantity = 1) => {
    const { data } = await $authHost.post('/api/basket', { deviceId, quantity }); // ← без /add
    return data;
};

export const updateQuantity = async (id, quantity) => {
    const { data } = await $authHost.put(`/api/basket/${id}`, { quantity });
    return data;
};

export const removeFromBasket = async (id) => {
    const { data } = await $authHost.delete(`/api/basket/${id}`);
    return data;
};

export const clearBasket = async () => {
    const { data } = await $authHost.delete('/api/basket');
    return data;
};
